import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard.jsx';
import Navbar from './components/Navbar.jsx';
import Sidebar from './components/Sidebar.jsx';
import './styles.css';
import BillsAndPayments from "./pages/BillsAndPayments";
import BillDetail from "./pages/BillDetail";
import Income from "./pages/Income";
import Transactions from "./pages/Transactions";
import ActionItems from "./pages/ActionItems";
import Tasks from "./pages/Tasks";
import Settings from "./pages/Settings";
import ComingSoon from "./pages/ComingSoon";
import Analysis from "./pages/Analysis";
import AutopayCheckModal from "./components/AutopayCheckModal";
import { useTheme } from "./theme/ThemeContext";
import { useSettings } from "./settings/SettingsContext";
import AdminDashboard from "./admin/AdminDashboard";
import { useMe } from "./admin/useMe";
function App() {
  const [collapsed, setCollapsed] = useState(false);
  const { tokens, fonts } = useTheme();
  const { settings } = useSettings();
  const me = useMe();
  const isAdmin = !!(me && me.isAdmin);

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <Router>
      <Navbar collapsed={collapsed} toggleSidebar={toggleSidebar} />
      <Sidebar collapsed={collapsed} isAdmin={isAdmin} />
      {settings.autopayReminders && <AutopayCheckModal />}

      <main
        style={{
          marginLeft: collapsed ? "60px" : "250px",
          marginTop: "60px",
          padding: "16px",
          transition: "margin-left 0.3s ease, background-color 0.2s ease",
          backgroundColor: tokens.bg,
          minHeight: "100vh",
          fontFamily: fonts.body,
        }}
      >
       {/* Replace welcome text with Dashboard component */}
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/bills-and-payments" element={<BillsAndPayments />} />
          <Route path="/bills-and-payments/:id" element={<BillDetail />} />
          <Route path="/income" element={<Income />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/action-items" element={<ActionItems />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/analysis" element={<Analysis />} />
          <Route path="/settings" element={<Settings />} />
          {isAdmin && (
            <Route
              path="/admin"
              element={
                <div style={{ maxWidth: 960 }}>
                  <h1 style={{ margin: "4px 0 12px", fontFamily: fonts.display, fontSize: 24, color: tokens.textPrimary }}>User analytics</h1>
                  <AdminDashboard />
                </div>
              }
            />
          )}
          <Route path="*" element={<ComingSoon title="Page Not Found" />} />
        </Routes>
        
      </main>
    </Router>
  );
}

export default App;